// extracted by mini-css-extract-plugin
module.exports = {"accessibility":"accessibility-override_accessibility__MtlTh"};